import React, { useState, useEffect } from 'react';
import {
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  SelectChangeEvent,
} from '@mui/material';

interface DropdownProps {
  onSelect: (selectedOption: string) => void;
  defaultVersion: string;
}

const VersionSelect: React.FC<DropdownProps> = ({
  onSelect,
  defaultVersion,
}) => {
  const [selectedOption, setSelectedOption] = useState<string>(defaultVersion);

  const options = ['ESV', 'WEB', 'KJV', 'ASV'];

  useEffect(() => {
    setSelectedOption(defaultVersion);
  }, [defaultVersion]);

  const handleChange = (event: SelectChangeEvent<string>) => {
    const newValue = event.target.value;
    setSelectedOption(newValue);
    onSelect(newValue);
  };

  return (
    <div className='flex justify-end w-80'>
      <FormControl variant='outlined' size='small' className='w-24'>
        <InputLabel id='version-select-label'>Version</InputLabel>
        <Select
          labelId='version-select-label'
          value={selectedOption}
          onChange={handleChange}
          label='Version'
        >
          {options.map((option) => (
            <MenuItem key={option} value={option}>
              {option}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </div>
  );
};

export default VersionSelect;
